import { withInstall } from '../../utils'

import _Status from './src/status.vue'

export const SdStatus = withInstall(_Status)
export default SdStatus

export * from './src/status'
